"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipProvider = exports.TooltipContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TooltipContext = /*#__PURE__*/_react.default.createContext({});

exports.TooltipContext = TooltipContext;

const TooltipProvider = ({
  children,
  tooltipPosition
}) => /*#__PURE__*/_react.default.createElement(TooltipContext.Provider, {
  value: {
    tooltipPosition
  }
}, children);

exports.TooltipProvider = TooltipProvider;
TooltipProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  tooltipPosition: _propTypes.default.oneOf(["top", "bottom", "left", "right"])
};